export const MAX_RESOURCE_TYPE_COUNT = 100;
export const MAX_RESOURCE_ITEM_COUNT = 10;
// Must match: vue/src/modules/common/constants/resources.js
// BE validation: https://github.com/vcita/resources/blob/master/src/scheduling/dto/request-create-resource.dto.ts#L8
export const MAX_RESOURCE_NAME_LENGTH = 40;

export const RESOURCE_TYPES_PAGE_SIZE = MAX_RESOURCE_TYPE_COUNT;
export const RESOURCES_PAGE_SIZE = MAX_RESOURCE_TYPE_COUNT * MAX_RESOURCE_ITEM_COUNT;
